const ROLES = {
  ADMIN: 'Admin',
  AGENT: 'Agent',
  AGENT_ADMIN: 'AgentAdmin',
  AGENT_OFFICE_ADMIN: 'AgentOfficeAdmin',
  COMPLIANCE: 'Compliance',
  COMPLIANCE_ADMIN: 'ComplianceAdmin',
  OFFICE_ADMIN: 'OfficeAdmin',
  CLOSING_MEMBER: 'ClosingMember',
  MANAGING_BROKER: 'ManagingBroker',
  TRANSACTION_COORDINATOR: 'TransactionCoordinator',
  VIEWER: 'Viewer',
};

const ROLES_CONFIG: Record<string, { roleName: string }> = {
  [ROLES.ADMIN]: {
    roleName: 'Admin',
  },
  [ROLES.AGENT]: {
    roleName: 'Agent',
  },
  [ROLES.AGENT_ADMIN]: {
    roleName: 'Company Admin',
  },
  [ROLES.COMPLIANCE]: {
    roleName: 'Compliance',
  },
  [ROLES.COMPLIANCE_ADMIN]: {
    roleName: 'Compliance Admin',
  },
  [ROLES.OFFICE_ADMIN]: {
    roleName: 'Office Admin',
  },
  [ROLES.CLOSING_MEMBER]: {
    roleName: 'Closing Member',
  },
  [ROLES.MANAGING_BROKER]: {
    roleName: 'Managing Broker',
  },
  [ROLES.TRANSACTION_COORDINATOR]: {
    roleName: 'Transaction Coordinator',
  },
  [ROLES.VIEWER]: {
    roleName: 'Viewer',
  },
};

export { ROLES, ROLES_CONFIG };
